import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import get from 'lodash/get';
import size from 'lodash/size';
import { pending, rejected } from 'redux-saga-thunk';
import { Modal, notification } from 'antd';
import moment from 'moment';
import Campaign from '../../components/pages/Campaign/index';
import {
  resourceDetailReadRequest,
  resourceUpdateRequest,
  resourceCreateRequest,
  resourceListReadRequest,
} from '../../store/resource/actions';
import { modalShow } from '../../store/modal/actions';
import { setEditRecord } from '../../store/updateCampaign/actions';
import { setCopiedLineItems, clearCopiedLineItems } from '../../store/lineItems/actions';
import { fromEntities, fromResource } from '../../store/selectors';
import CampaignsAdd from './CampaignsAdd';
import { StatusLabel } from '../../services/helper/index';
import LineItemAdd from './lineitem/LineItemAdd';

const { confirm } = Modal;

class CampaignContainer extends Component {
  static defaultProps = {
    campaign: [],
    lineItemList: [],
  };

  static propTypes = {
    lineItemList: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        type: PropTypes.string,
        status: PropTypes.boolean,
        start_date: PropTypes.string,
        end_date: PropTypes.string,
        impressions: PropTypes.number,
      })
    ),
    updateCampaign: PropTypes.func.isRequired,
    getCampaign: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    saveCopiedLineItems: PropTypes.func.isRequired,
  };

  state = {
    archived: false,
    tableState: {
      filteredInfo: { status: ['Unarchived'] },
      page: 0,
      pageSize: 10,
      sortField: null,
      sortOrder: null,
      searchTerm: null,
    },
    selectedRowKeys: [],
  };

  componentDidMount() {
    this.props.getCampaign().catch(e =>
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not retrieve campaign.',
        duration: 0,
      })
    );
    this.fetchTableData();
  }

  onSelectedRowKeysChange = selectedRowKeys => {
    this.setState({ selectedRowKeys });
  };

  onSelectedRowKeysChange = selectedRowKeys => {
    this.setState({ selectedRowKeys });
  };

  confirmLineItems = (adIds, lineItemNames) => {
    confirm({
      title: 'Hey!',
      content: `This campaign has a different advertiser than your original line item, your line items: ${lineItemNames.toString()}, will not be copied over.`,
      onOk: () => {
        this.props.clearCopiedLineItems();
      },
    });
  };

  fetchTableData = () => {
    this.props
      .getLineItemList({
        ...this.state.pagination,
        ...this.state.tableState,
        archived: this.state.archived,
      })
      .then(() =>
        this.setState({
          pagination: { ...this.state.pagination, total: this.props.campaignAdCount },
        })
      )
      .catch(e => {
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not retrieve line item list.',
          duration: 0,
        });
      });
  };

  formatDate = dateStr => (dateStr ? moment(dateStr).format('MM/DD/YYYY') : '');

  handleAction = action => {
    const selectedLineItems = [];
    const { selectedRowKeys } = this.state;
    const lineItems = this.props.copiedLineItems;
    this.props.lineItemList.forEach(i => {
      if (selectedRowKeys.indexOf(i.id) !== -1) {
        // Add advertiser_uuid incase line items are copied to another advertiser.
        const item = i;
        item.advertiser_uuid = this.props.campaign.advertiser_uuid;
        selectedLineItems.push(item);
      }
    });

    switch (action) {
      case 'edit-campaign':
        this.props.setEditRecord(this.props.campaign);
        this.props.showNewCampaignModal();
        break;
      case 'copy-line':
        this.props.setCopiedLineItems(selectedLineItems);
        notification.success({
          message: 'Success',
          description: 'Line items copied!',
          duration: 4,
        });
        break;
      case 'paste-line':
        this.props.clearCopiedLineItems();

        if (!lineItems.length) {
          notification.error({
            message: 'Error',
            description: 'No line items were copied.',
            duration: 0,
          });
          return false;
        }

        this.saveLineItems(lineItems.map(a => a.id));
        break;

      case 'review':
        this.props
          .updateAdApprovalStatus(
            'In Review',
            selectedLineItems.map(a => a.id)
          )
          .then(() => {
            notification.success({
              message: 'Success',
              description: 'Line items marked In Review',
              duration: 4,
            });
          })
          .then(() => {
            this.props.clearCopiedLineItems();
            this.setState({ selectedRowKeys: [] });
            this.fetchTableData();
          });
        break;
      case 'approve':
        this.props
          .updateAdApprovalStatus(
            'Approved',
            selectedLineItems.map(a => a.id)
          )
          .then(() => {
            notification.success({
              message: 'Success',
              description: 'Line items marked Approved',
              duration: 4,
            });
          })
          .then(() => {
            this.props.clearCopiedLineItems();
            this.setState({ selectedRowKeys: [] });
            this.fetchTableData();
          });
        break;

      default:
        return false;
    }
  };

  handleArchiveCampaigns = () => this.updateStatus(3);

  handlePauseCampaigns = () => this.updateStatus(2);

  handleRunCampaigns = () => this.updateStatus(1);

  handleSearchTable(searchTerm) {
    // Clear sorting, pagination and search.
    const { pageSize } = this.state.tableState;
    this.setState(
      {
        tableState: {
          sortField: null,
          sortOrder: null,
          page: 0,
          pageSize,
          searchTerm,
        },
      },
      () => {
        this.fetchTableData();
      }
    );
  }

  handleTableChange = (pagination, filters, sorter) => {
    const pager = {
      ...this.state.pagination,
      current: pagination.current,
      total: this.props.campaignAdCount,
    };

    // Update state and fetch table data, pagination and sorter.  Filters are handled by search.
    const updateTableState = this.state.tableState;

    updateTableState.filteredInfo = filters;

    if (sorter) {
      updateTableState.sortField = sorter.columnKey;
      updateTableState.sortOrder = sorter.order;
    }

    this.setState({ pagination: pager, tableState: updateTableState }, () => {
      this.fetchTableData();
    });
  };

  saveLineItems = adIds => {
    if (!adIds.length) {
      return false;
    }
    this.setState({ selectedRowKeys: [] });
    const pasteItem = {
      advertiser_ad_ids: adIds,
      campaign_id: this.props.campaign.id,
    };
    this.props
      .saveCopiedLineItems(pasteItem)
      .then(() => {
        notification.success({ message: 'Success', description: 'Line items saved!', duration: 4 });
        this.fetchTableData();
      })
      .catch(e =>
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not save line items.',
          duration: 0,
        })
      );
  };

  toggleArchived = () => this.setState({ archived: !this.state.archived }, this.fetchTableData);

  updateStatus = statusId => {
    if (!this.state.selectedRowKeys.length) {
      notification.warn({
        message: 'Warning',
        description: 'Select a few rows first.',
        duration: 0,
      });
      return;
    }

    this.props
      .updateAdStatus(statusId, this.state.selectedRowKeys)
      .then(() => {
        notification.success({
          message: 'Success',
          description: 'Status successfully changed.',
          duration: 4,
        });
        this.setState({ selectedRowKeys: [] });
        this.fetchTableData();
      })
      .catch(e => {
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not submit status change.',
          duration: 0,
        });
      });
  };

  render() {
    const { selectedRowKeys, pagination, archived } = this.state;
    const disableActions = selectedRowKeys.length === 0;
    const disablePasteLineItems = size(this.props.copiedLineItems) === 0;

    const columns = [
      {
        title: 'Name',
        render: (text, record) => (
          <a
            onClick={e => {
              e.preventDefault();
              this.props.history.push(
                `/campaigns/${record.advertiser_campaign_id}/line/${record.id}`
              );
            }}
            href={`/campaigns/${record.advertiser_campaign_id}/line/${record.id}`}
          >
            {text}
          </a>
        ),
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        render: text => <StatusLabel status={text} />,
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (text, record) => <StatusLabel record={record} />,
      },
      {
        title: 'Start Date',
        dataIndex: 'start_date',
        key: 'start_date',
        render: text => this.formatDate(text),
      },
      {
        title: 'End Date',
        dataIndex: 'end_date',
        key: 'end_date',
        render: text => this.formatDate(text),
      },
    ];

    return [
      <LineItemAdd key={1} />,
      <CampaignsAdd key={2} handleUpdateCampaign={this.props.updateCampaign} />,
      <Campaign
        key={3}
        pagination={pagination}
        archived={archived}
        toggleArchived={this.toggleArchived}
        tableData={this.props.lineItemList}
        columns={columns}
        handleAction={action => {
          this.handleAction(action);
        }}
        handleTableChange={this.handleTableChange}
        handlePauseCampaigns={this.handlePauseCampaigns}
        handleRunCampaigns={this.handleRunCampaigns}
        handleArchiveCampaigns={this.handleArchiveCampaigns}
        handleSearchTable={searchTerm => {
          this.handleSearchTable(searchTerm);
        }}
        selectedRowKeys={selectedRowKeys}
        onSelectedRowKeysChange={this.onSelectedRowKeysChange}
        disableTableActions={disableActions}
        disableCopyLineItems={disableActions}
        disablePasteLineItems={disablePasteLineItems}
        loading={this.props.loading}
        creatingNewLineItem={this.props.creatingNewLineItem}
        {...this.props}
      />,
    ];
  }
}

const mapStateToProps = (
  state,
  {
    match: {
      params: { campaignId },
    },
  }
) => ({
  campaignAdCount: get(state, 'resource.advertiserCampaignAdvertiserAd.count', 0),
  loading:
    pending(state, 'advertiserAdApprovalStatusUpdate') ||
    pending(state, 'advertiserCampaignPasteCreate') ||
    pending(state, 'advertiserCampaignStatusUpdate') ||
    pending(state, 'advertiserCampaignDetailRead') ||
    pending(state, 'advertiserCampaignAdvertiserAdListRead'),
  creatingNewLineItem: pending(state, 'advertiserAdCreate'),
  rejectedCampaign: rejected(state, 'advertiserCampaignDetailRead'),
  campaign: fromEntities.getDetail(state, 'advertiserCampaign', campaignId),
  copiedLineItems: Object.values(get(state, 'lineItems', {})),
  lineItemList: fromEntities.getList(
    state,
    'advertiserCampaignAdvertiserAd',
    fromResource.getList(state, 'advertiserCampaignAdvertiserAd')
  ),
});

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { campaignId },
    },
  }
) => ({
  updateAdApprovalStatus: (statusLabel, campaignIds) =>
    dispatch(
      resourceUpdateRequest(
        'advertiser-ad/approval-status/:statusLabel',
        { statusLabel },
        campaignIds
      )
    ),
  handleCreateLineItem: () => dispatch(modalShow('LineItemAdd')),
  setEditRecord: record => dispatch(setEditRecord(record)),
  showNewCampaignModal: () => dispatch(modalShow('add-campaign')),
  setCopiedLineItems: lineItems => dispatch(setCopiedLineItems(lineItems)),
  clearCopiedLineItems: () => dispatch(clearCopiedLineItems()),
  saveCopiedLineItems: data =>
    dispatch(resourceCreateRequest('advertiser-campaign/paste', {}, data)),
  updateAdStatus: (statusId, campaignIds) =>
    dispatch(resourceUpdateRequest('advertiser-ad/status/:statusId', { statusId }, campaignIds)),
  updateCampaign: values =>
    dispatch(resourceUpdateRequest('advertiser-campaign/:id', { id: campaignId }, values)),
  getCampaign: () =>
    dispatch(resourceDetailReadRequest('advertiser-campaign/:id', { id: campaignId })),
  getLineItemList: ({ searchTerm, current, pageSize, archived }) =>
    dispatch(
      resourceListReadRequest(
        'advertiser-campaign/:campaignId/advertiser-ad',
        {
          q: searchTerm,
          page_num: current,
          page_size: pageSize,
          archived: !archived ? undefined : true,
        },
        {
          campaignId,
        }
      )
    ),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(CampaignContainer);
